import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { SwitchInput } from 'Packages/FacetDesign/Components/SwitchInput';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('disabled', {
    _component: () => SwitchInput,
  }, overrideReadOnly);

export default metaOverrideSet;
